import token from '@uipath/apollo-core';
export const MuiSlider = () => ({
    root: {
        fontSize: token.FontFamily.FontMSize,
        '& .MuiSlider-valueLabel': { fontSize: token.FontFamily.FontMSize },
    },
});
